<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pGo74/tc-custom/9781439187814.jpg?1730521355580" alt="This image is the cover for the book Web of Dreams, Casteel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Web of Dreams, Casteel
      </h1>
      <p class="bookDescription body article font2">
        <b>The family curse arises in the final Casteel novel from the #1 <i>New York Times</i>–bestselling author of <i>Flowers in the Attic</i>—now a Lifetime movie series event.</b><br/><br/>Leigh VanVoreen had to escape from Boston’s Farthinggale Manor. The foul secret she harbored within her seemed to darken her life forever. Jillian, her mother, would not believe her, and Tony Tatterton, her stepfather, had betrayed her cruelly.<br/><br/>But the pure devotion of Luke Casteel promised her hope and respect. Only Luke knew her deepest of secrets . . . only Luke would love and protect her. Bravely she bore the suspicions of the Willies’ hillfolk, as she tried to grasp the happiness that had so long eluded her. Leigh prayed with all her heart that her bright, shining dreams would save her from tragedy at last . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        V. C. Andrews
      </h2>
      
      <p class="authorDescription body article">One of the most popular authors of all time,&#160;V.C. Andrews&#160;has been a bestselling phenomenon since the publication of&#160;<I>Flowers in the Attic</I>, first in the renowned Dollanganger family series, which includes&#160;<I>Petals on the Wind</I>,&#160;<I>If There Be Thorns</I>,&#160;<I>Seeds of Yesterday</I>, and&#160;<I>Garden of Shadows</I>. The family saga continues with&#160;<I>Christopher&rsquo;s Diary: Secrets of Foxworth</I>,&#160;<I>Christopher&rsquo;s Diary: Echoes of Dollanganger</I>, and&#160;<I>Secret Brother</I>, as well as&#160;<I>Beneath the Attic</I>,&#160;<I>Out of the Attic</I>, and&#160;<I>Shadows of Foxworth&#160;</I>as part of the fortieth anniversary celebration. There are more than ninety V.C. Andrews novels, which have sold over 107 million copies worldwide and have been translated into more than twenty-five foreign languages.&#160;Andrews&rsquo;s life story is told in <I>The Woman Beyond the Attic</I>.&#160;Join the conversation about the world of V.C. Andrews at Facebook.com/OfficialVCAndrews.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5175b624